import { useState } from "react";
import Home from "./components/Home/Home";
import LandingPage from "./components/LandingPage/LandingPage";
import bird from "./assets/ideatank.svg";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

function App() {
  const [route, setroute] = useState("landing");
  const [myName, setmyName] = useState("Anonymous");

  useState(() => {
    if (localStorage.getItem("expiry") < Date.now()) {
      localStorage.clear();
      setroute("landing");
    } else {
      //add one more condition to check if accessToken is valid
      setmyName(JSON.parse(localStorage.getItem("User")).name);
      setroute("home");
    }
  }, []);

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      // console.log(codeResponse);
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/auth/google`, {
          code: codeResponse.code,
        })
        .then((res) => {
          // console.log(res);
          localStorage.setItem(
            "accessToken",
            JSON.stringify(res.data.tokens.access_token)
          );
          localStorage.setItem(
            "expiry",
            JSON.stringify(res.data.tokens.expiry_date)
          );
          localStorage.setItem("User", JSON.stringify(res.data.user));
          setLoginFunction(res.data.user.name);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onError: (errorResponse) => console.log(errorResponse),
  });

  const setLoginFunction = (user) => {
    setmyName(user);
    setroute("home");
  };

  const setLogoutFunction = () => {
    googleLogout();
    setmyName("Anonymous");
    localStorage.clear();
    setroute("landing");
    window.location.reload();
  };

  const routing = (key) => {
    switch (key) {
      case "home":
        return <Home myName={myName} route={route} />;
      case "landing":
        return <LandingPage />;
      default:
        return (
          <h2 style={{ textAlign: "center" }}>Error 404 : Page Not Found</h2>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen grow">
      <div className="navbar bg-base-100 h-1.5">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
          </div>
          <img src={bird} alt="" className="h-16 p-2 ml-2" />
        </div>
        <div  className="navbar-centre">
        <h1 className=" rounded">Ideatank<sup>Alpha</sup></h1>
        </div>
        <div className="navbar-end">
          {route === "landing" ? (
            <button
              className="btn btn-primary ml-2 rounded"
              onClick={googleLogin}
            >
              Login with Google
            </button>
          ) : (
            <button className="btn btn-error ml-2 rounded" onClick={setLogoutFunction}>Logout</button>
          )}
        </div>
      </div>
      {routing(route)}
    </div>
  );
}

export default App;
